import { trackEvent } from '../trackEvent'

export function trackMenuLinkEvent(type: string) {
  trackEvent({ event: 'Menu Button', params: { Type: type } })
}

export const trackTitleLink = () => trackEvent({ event: 'Title Link' })
